import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { ConfirmDialogModule } from '@portal-core/general/components/confirm-dialog/confirm-dialog.module';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { StopPropagationModule } from '@portal-core/general/directives/stop-propagation/stop-propagation.module';
import { ProjectChecklistColumnMenuComponent } from './project-checklist-column-menu.component';

@NgModule({
  declarations: [
    ProjectChecklistColumnMenuComponent
  ],
  imports: [
    CommonModule,
    MatMenuModule,
    MatIconModule,
    MatListModule,
    LoaderModule,
    ConfirmDialogModule,
    ErrorsExpansionPanelModule,
    StopPropagationModule
  ],
  exports: [
    ProjectChecklistColumnMenuComponent
  ]
})
export class ProjectChecklistColumnMenuModule { }
